import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Records from '../Records'
import * as UI from '../../Shared.styles'
import Mixin from 'components/common/Mixin'
import { SPEAKABLE_SUMMARY } from 'constant'
import BrandsSchemasHelmet from '../BrandsSchemasHelmet'

export const CompatibleBrandResultList = ({ records, vehicleName }) =>
  <>
    <BrandsSchemasHelmet />

    <UI.Wrapper data-at-compatible-brand-results-list>
      <UI.Title data-at-title headline headline_narrow centered>Shop By Tire Brand</UI.Title>
      <UI.Description data-at-description className={ SPEAKABLE_SUMMARY }>
        Big O Tires brings the world’s best tire brands together under one roof.
      </UI.Description>
      {
        records.length > 0 &&
        <Text data-at-compatible-text>Currently Compatible with your { vehicleName }</Text>
      }
      <Records records={ records } />
    </UI.Wrapper>
  </>


CompatibleBrandResultList.propTypes = {
  records: PropTypes.arrayOf(PropTypes.shape()),
  vehicleName: PropTypes.string
}

const Text = styled.div`
  text-align: left;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(16)}
  ${Mixin.responsive('margin', '70px 20px 25px', '40px 16px 20px')}
`
